import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import moment, { Moment } from 'moment';
import { Address } from 'src/app/models/onboarding';
import { AlertService } from 'src/app/services/alert/alert.service';
import { ExtLinkService } from 'src/app/services/ext-link/ext-link.service';
import { IonSlides, Platform } from '@ionic/angular';
import { LOGO_PATH_ONLY_MASCOTTE, PROFILE_TYPE } from 'src/app/constants';
import { ModalController } from '@ionic/angular';
import { Onboarding } from 'src/app/models/onboarding';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';
import { Place } from 'src/app/models/place';
import { ProfileFormBaseComponent } from '../../../components/profile-form/profile-form-base.component';
import { ProfileSelectTypeComponent } from 'src/app/components/profile-select-type/profile-select-type.component';
import { Storage } from '@ionic/storage';
import { TitleService } from 'src/app/services/title/title.service';
import { TranslateService } from '@ngx-translate/core';
import { setFormTouched } from 'src/app/utils/form';
import { Router } from '@angular/router';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import jwtDecode from 'jwt-decode';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { Profile } from 'src/app/models/profile';
import { LocationStrategy } from '@angular/common';
import { FirebaseService } from 'src/app/services/firebase-analytics/firebase.service';
import { ITALY_CODE } from 'src/app/components/profile-form/options';

@Component({ 
  selector: 'app-tutorial', 
  templateUrl: './tutorial.page.html',
  styleUrls: ['./tutorial.page.scss'],
})
export class TutorialPage extends ProfileFormBaseComponent implements OnInit {

  @ViewChild(IonSlides, { static: false }) ionSlides: any;
  sliderOptions = { initialSlide: 0, speed: 400 };
  sliderPager: boolean = false;
  logoPath: string = LOGO_PATH_ONLY_MASCOTTE;
 
  onboardingFormSlideOne: FormGroup;
  onboardingFormSlideTwo: FormGroup;
  onboarding: Onboarding = new Onboarding();
  profile: Profile;

  constructor(
    protected formBuilder: FormBuilder,
    protected modalController: ModalController,
    protected translateService: TranslateService,
    protected alertService: AlertService,
    protected extLinkService: ExtLinkService,
    protected storage: Storage,
    private router: Router,
    private titleService: TitleService,
    private onboardingService: OnboardingService,
    private spinnerService: SpinnerService,
    private profileService: ProfileService,
    private authService: AuthService,
    private locationStrategy: LocationStrategy,
    private firebaseService: FirebaseService,
    private platform: Platform,
  ) { 
    super(formBuilder, modalController, translateService, alertService, extLinkService, storage);

    this.onboardingFormSlideOne = this.formBuilder.group({
      firstName: [{ value: null, disabled: false }, [Validators.required]],
      lastName: [{ value: null, disabled: false }, [Validators.required]],
      birthDate: [{ value: null, disabled: false }, [Validators.required]],
      birthPlace: [{ value: null, disabled: false }, [Validators.required]],
    });
    this.onboardingFormSlideTwo = this.formBuilder.group({
      city: [{ value: null, disabled: false }, [Validators.required]],
      cap: [{ value: null, disabled: false }, [Validators.required]],
      street: [{ value: null, disabled: false }, [Validators.required]],
      country: [{ value: null, disabled: false }, [Validators.required]],
      taxCode: [{ value: '', disabled: false }, this.foreignTaxCodeValidator],
      cellPhone: [{ value: null, disabled: false }, [Validators.required]],
    });
  }

  async ngOnInit() {
    this.locationStrategy.replaceState('', '', '/onboarding/tutorial', '?slide=1');

    await this.openSelectType();
    await this.initProfile();

    await this.syncProfileNames();
  }

  async openSelectType() {
    const modalProfileType = await this.modalController.create({
      backdropDismiss: false,
      showBackdrop: false,
      component: ProfileSelectTypeComponent,
    });

    modalProfileType.onDidDismiss()
      .then(async ({ data }: { data: { type: PROFILE_TYPE } }) => {
        if (data) {
          switch (data.type) {
            case PROFILE_TYPE.private: {
              await this.storage.set('profileType', data.type);
              break;
            }
            case PROFILE_TYPE.professional: {
              await this.storage.set('profileType', data.type);
              this.router.navigate(['/profile'], { replaceUrl: true });
              break;
            }
            case PROFILE_TYPE.company: {
              await this.storage.set('profileType', data.type);
              this.router.navigate(['/profile'], { replaceUrl: true });
              break;
            }
            default: { }
          }  
        } else { // TIP when user closes modal remove old profileType preferences setted by other profile sessions
          await this.storage.remove('profileType');
        }
      });

    return await modalProfileType.present();
  }

  async initProfile() {
    try {
      await this.spinnerService.show();

      const token = await this.authService.getToken();
      const decoded = jwtDecode(token);
      console.log('Decoded token', decoded);
      this.onboarding.email = decoded['https://speedlinetrasporti.com/email'];
        console.log('Email from token', this.onboarding.email);
      this.profile = await this.profileService.me(token);

      await this.spinnerService.dismiss();
    } catch (err) {
      console.log(err);
      await this.spinnerService.dismissWithAlertError(err);
    }
  }

  selectedBirthDate(date: Moment) {
    this.onboardingFormSlideOne.get('birthDate').setValue(date.format(this.dateFormat));
  }

  selectedBirthplace(place: Place) {
    const { description = '' } = place;
    this.onboardingFormSlideOne.get('birthPlace').setValue(description);
  }

  selectedAddressCity(place: Place) {
    const { address = '', cap = '', city = '', country = '' } = place;
    this.onboardingFormSlideTwo.get('cap').setValue(cap);
    this.onboardingFormSlideTwo.get('city').setValue(city);
    this.onboardingFormSlideTwo.get('country').setValue(country);
  }

  nextWithBtn() {
    this.ionSlides.slideNext();
  }

  next() {
    this.ionSlides.getActiveIndex()
      .then(async (index: number) => {
        switch(index) {
          case 0: { // TIP move slide from 2 to 1
            this.locationStrategy.replaceState('', '', '/onboarding/tutorial', '?slide=1');
            const text = await this.translate.get('WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1').toPromise();
            this.titleService.setTitle(text);

            if (this.platform.is('cordova')) {
              this.firebaseService.firebaseScreenName('/onboarding/tutorial?slide=1');
            }

            break;
          }
          case 1: { // TIP move slide from 1 to 2
            this.locationStrategy.replaceState('', '', '/onboarding/tutorial', '?slide=2');
            const text = await this.translate.get('WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_2').toPromise();
            this.titleService.setTitle(text);

            if (this.platform.is('cordova')) {
              this.firebaseService.firebaseScreenName('/onboarding/tutorial?slide=2');
            }

            this.storage.set('onboardingFormSlideOne', this.onboardingFormSlideOne.value)
              .then(() => { 
                const chunkedData = this.onboardingFormSlideOne.getRawValue();
                const { birthDate } = chunkedData;
                Object.keys(chunkedData).forEach(key => this.onboarding[key] = chunkedData[key]);
                this.onboarding.birthDate = birthDate ? moment(birthDate, 'DD-MM-YYYY').toDate() : null;
                this.syncData(this.onboarding);     
                }
              );
            
            break;
          }
          default: { }
        }
      }
    );
  }

  async syncData(onboarding: Onboarding) {
    try {
      await this.onboardingService.create(onboarding);
    } catch (err) {
    }
  }

  async jumpToSummaryProfilePage() {
    if (!this.onboardingFormSlideOne.valid) {
      setFormTouched(this.onboardingFormSlideOne);
      this.ionSlides.slideTo(0, 1100);
      return;
    }

    if (!this.onboardingFormSlideTwo.valid) {
      setFormTouched(this.onboardingFormSlideTwo);
      return;
    }

    let type: string;
    await this.storage.get('profileType')
      .then(async (value) => {
        type = value;
        if (!value) { this.openSelectType(); }
      });
    if (!type) { return; }

    this.storage.set('onboardingFormSlideTwo', this.onboardingFormSlideTwo.value)
      .then(() => {
        this.onboarding.address = new Address();
        const { taxCode: taxCode, cellPhone: cellPhone, ...address } = this.onboardingFormSlideTwo.getRawValue();
        this.onboarding.address = address;
        this.onboarding.taxCode = taxCode || '';
        this.onboarding.cellPhone = cellPhone;
        this.syncData(this.onboarding);
        }
      );

    if (this.isRetired()) {
      await this.alertService.translate('RETIRED_PROFILE_ERROR');
      return;
    }

    this.router.navigate(['/profile'], { replaceUrl: true });
  }

  isRetired() {
    const age = moment().diff(moment(this.onboarding.birthDate, this.dateFormat), 'years');
    return age > 75;
  }

  foreignTaxCodeValidator(formControl: AbstractControl): ValidationErrors | null {
    if (formControl.parent && formControl.parent.get('country')) {
      const currentFormControl = formControl.parent.get('country');
      const country = currentFormControl ? currentFormControl.value : null;
      const taxCode = formControl.value;
  
      if (country === ITALY_CODE && !taxCode) {
        return { required: true };
      }
    }
  
    return null;
  }

  async syncProfileNames() {
    try {
      const names = await this.profileService.getProfileNames(await this.authService.getToken());
      const { first_name = '', last_name = '' } = names || {};
      console.log('Profile names synced', names);
      this.onboardingFormSlideOne.get('firstName').setValue(first_name);
      this.onboardingFormSlideOne.get('lastName').setValue(last_name);
    } catch (err) {
      console.log(err);
    }
  }
}
